import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-banner-object',
  templateUrl: './banner-object.component.html',
  styleUrls: ['./banner-object.component.css']
})
export class BannerObjectComponent implements OnInit {


  // datos   a traspasar  (titulo , texto , cantidad pendiente (solo solicitudes ),  accion client redirencccion  a  paginas  )
  @Input() title: string = ' ';
  @Input() explanatoryText: string = ' ';
  // @ Input()   optionData?:string ="<span class="rounded-circle">5</span>";
  totalPending?: number = 0;
  constructor() { }

  ngOnInit(): void {
  }

}
